module.exports = __webpack_public_path__ + "img/download.19bc66da.svg";